<template>
  <div class="aih-root">
    <div class="aih-left">
      <div class="aih-icon-wrap">
        <v-icon size="14" color="#6366f1">mdi-clipboard-check-outline</v-icon>
      </div>
      <div class="aih-title-group">
        <span class="aih-title">Assigned to Me</span>
        <span class="aih-subtitle">Your active tasks</span>
      </div>
    </div>

    <div class="aih-right">
      <transition name="aih-expand">
        <div class="aih-search-pill" v-if="searchClicked" ref="searchContainer">
          <v-icon size="14" color="#a5b4fc">mdi-magnify</v-icon>
          <input
            v-model="searchQuery"
            @input="getSearch"
            class="aih-search-input"
            placeholder="Search…"
            autofocus
          />
          <button class="aih-close-btn" @click.stop="toggleSearch">
            <v-icon size="12" color="#94a3b8">mdi-close</v-icon>
          </button>
        </div>
      </transition>

      <button class="aih-action-btn" @click.stop="toggleSearch" v-if="!searchClicked" title="Search">
        <v-icon size="15" color="#6366f1">mdi-magnify</v-icon>
      </button>

      <button class="aih-action-btn" id="aih-filter-btn" title="Filter">
        <v-icon size="15" color="#6366f1">mdi-tune-variant</v-icon>
      </button>
      <v-menu v-model="menu" activator="#aih-filter-btn" transition="scale-transition"
        :close-on-content-click="false" location="bottom end">
        <v-list width="350px" class="pa-0">
          <DashboardFilter :type="'openIssue'" :existFilterData="filterData" @applyChange="filterTheData" />
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import DashboardFilter from "../Widgets/DashboardFilter.vue";
export default {
  components: { DashboardFilter },
  props: ["filterData"],
  data() {
    return { menu: false, searchClicked: false, searchQuery: "" };
  },
  methods: {
    getSearch() { this.$emit("getSearch", this.searchQuery); },
    filterTheData(data) { this.$emit("filterTaskData", data); this.menu = false; },
    toggleSearch() {
      this.searchClicked = !this.searchClicked;
      if (this.searchClicked) document.addEventListener("click", this.handleOutsideClick);
      else document.removeEventListener("click", this.handleOutsideClick);
    },
    handleOutsideClick(event) {
      if (this.$refs.searchContainer && !this.$refs.searchContainer.contains(event.target)) {
        this.searchClicked = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
  },
};
</script>

<style scoped>
.aih-root {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px 14px;
  background: #ffffff;
  border-bottom: 1px solid #f0f4ff;
}

.aih-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.aih-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  border: 1px solid rgba(99, 102, 241, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.aih-title-group {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.aih-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.2px;
  line-height: 1.2;
}

.aih-subtitle {
  font-size: 10.5px;
  color: #94a3b8;
  font-weight: 400;
  line-height: 1;
}

.aih-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.aih-action-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #e8edf5;
  background: #fafbff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, transform 0.12s;
}
.aih-action-btn:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
  transform: translateY(-1px);
}

.aih-search-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fafbff;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  padding: 0 10px;
  height: 30px;
  width: 170px;
}
.aih-search-pill:focus-within { border-color: #818cf8; box-shadow: 0 0 0 3px rgba(99,102,241,0.1); }

.aih-search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 12px;
  color: #1e293b;
  min-width: 0;
}
.aih-search-input::placeholder { color: #94a3b8; }

.aih-close-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  flex-shrink: 0;
}

.aih-expand-enter-active, .aih-expand-leave-active { transition: width 0.22s ease, opacity 0.22s ease; }
.aih-expand-enter-from, .aih-expand-leave-to { width: 0; opacity: 0; }
</style>
